import { render, staticRenderFns } from "./menu-sub.vue?vue&type=template&id=f05031ae&"
import script from "./menu-sub.vue?vue&type=script&lang=js&"
export * from "./menu-sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menu-sub.vue"
export default component.exports